module.exports = __webpack_public_path__ + "img/bg8.24611482.png";